import React from 'react'

import { FormattedMessage } from 'react-intl'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'

import SideBar, { SideBarBlock, SideBarBlockItem } from '@components/UI/SideBar'
import { BillingTypes, PageRoutes } from '@enums'
import {
  selectCampaignsBillingHistoryLink,
  selectContentLibraryBillingHistoryLink,
} from '@store/me'
import { selectBillingType } from '@store/router'

export const BillingHistorySideBar: React.FC = () => {
  const location = useLocation()
  const billingType = useSelector(() => selectBillingType(location))
  const hasCampaignsLink = useSelector(selectCampaignsBillingHistoryLink)
  const hasContentLibraryLink = useSelector(selectContentLibraryBillingHistoryLink)

  const items: ReadonlyArray<React.ReactNode> = [
    hasCampaignsLink && (
      <SideBarBlockItem
        active={billingType === BillingTypes.Campaigns}
        text={<FormattedMessage id="core.text.campaigns" />}
        to={`/${PageRoutes.BillingCampaigns}`}
      />
    ),
    hasContentLibraryLink && (
      <SideBarBlockItem
        active={billingType === BillingTypes.ContentLibrary}
        text={<FormattedMessage id="core.text.contentLibrary" />}
        to={`/${PageRoutes.BillingContentLibrary}`}
      />
    ),
  ].filter(Boolean)
  return (
    <SideBar key={billingType}>
      <SideBarBlock header={<FormattedMessage id="core.text.billing" />} items={items} />
    </SideBar>
  )
}

export default BillingHistorySideBar
